import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ValidationResultsModule } from '@max/shared/components/validation-results/validation-results.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ApiRequestComponent } from './api-request/api-request.component';
import { AuthRoutes } from './auth.routes';
import { LoginComponent } from './authentication/login.component';
import { LogoutComponent } from './authentication/logout.component';
import { BuSelectionComponent } from './business-unit/bu-selection.component';

@NgModule({
    declarations: [
        ApiRequestComponent,
        BuSelectionComponent,
        LoginComponent,
        LogoutComponent
    ],
    imports: [
        BsDropdownModule.forRoot(),
        CommonModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        RouterModule.forChild(AuthRoutes),
        ValidationResultsModule
    ],
    exports: [
        BuSelectionComponent,
        LoginComponent,
        LogoutComponent
    ]
})
export class AuthModule { }
